module.exports = __webpack_public_path__ + "img/voucher_5.6971715d.jpg";